module.exports = __webpack_public_path__ + "img/login_img.b423918a.png";